// extracted by mini-css-extract-plugin
module.exports = {"fallback":"Fallback_fallback__EW2jv","topSection":"Fallback_topSection__wNifd","contactUsLink":"Fallback_contactUsLink__hL23m","leftToRight":"Fallback_leftToRight__I4lul"};